<button
  [attr.disabled]="(selected$ | async) ? 'disabled' : null"
  [attr.aria-label]="ariaLabel ? ariaLabel : null"
  [ngClass]="effectiveClass$ | async"
  class="flex flex--center border-top border-bottom border-left ps-small"
  (click)="onToggle()"
  (focusin)="onFocus()"
  (focusout)="onBlur()"
>
  <fcom-generic-icon [url]="icons[IconLibrary.SVG_LIBRARY][icon]"></fcom-generic-icon>
</button>
